var generateComponentTheme = function generateComponentTheme(_ref) {
  var spacing = _ref.spacing,
    colors = _ref.colors,
    borders = _ref.borders;
  return {
    DnDZoneBorderWidth: borders.widthSmall,
    DnDZoneBorderColor: colors.tiara,
    DnDZoneBackgroundColor: colors.porcelain,
    DnDZonePadding: spacing.medium,
    // sidebar:
    sidebarDnDZoneBorderWidth: borders.widthSmall,
    sidebarDnDZoneBorderColor: colors.oxford,
    sidebarDnDZoneBackgroundColor: colors.porcelain,
    sidebarDnDZonePadding: spacing.small,
    sidebarDnDZoneMargin: spacing.xSmall,
    sidebarDnDZoneColor: colors.licorice
  };
};
export default generateComponentTheme;